// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__NTgWW","modalForm":"UpgradeEpcsModal_modalForm__3owdE","modalFooter":"UpgradeEpcsModal_modalFooter__1FabG"};